import React, { useState, useEffect, useMemo } from 'react';
import { Stage, Layer, Rect, Transformer, Image, Circle, Group } from 'react-konva';
import ZoomableStage from "./zoomableStage";
import RectSelector from './rectSelector';
import useImage from 'use-image';


const App = ({ width, height, url, boxes, onBoxesLengthChange,onRadiusChange ,optionRadius}) => {
  // 选框参数
  const [selectorProps, setSelectorProps] = useState({ x: width * 0.2, y: height * 0.2, width: width * 0.8, height: height * 0.8 })
  // 舞台参数
  const [stagePropes, setStagePropes] = useState({ x: 0, y: 0, width, height, scaleX: 0.01, scaleY: 0.01 })
  // 图片
  const [image] = useImage(url);
  // boxes 副本
  const [boxes_, setBoxes_] = useState([])
  // 框选后数据
  const [boxesSelector, setBoxesSelector] = useState([])
  const [isDraging, setIsDraging] = useState(false)


  // 舞台选框适配图片
  useEffect(() => {
    if (image) {
      const scaleX = width / image.width;
      const scaleY = height / image.height;
      const scale = Math.min(scaleX, scaleY);
      const y = (height - image.height * scale) / 2;
      const x = (width - image.width * scale) / 2;
      setSelectorProps({ x: image.width * 0, y: image.height * 0, width: image.width * 1, height: image.height * 1 })
      setStagePropes((pre) => { return { ...pre, x, y, scaleX: scale, scaleY: scale } })
    }
  }, [image]);

  // 选框过滤
  useEffect(() => {
    const { x, y, width, height } = selectorProps
    const newBoxes = boxes_.filter((box) => {
      return box.centerX > x && box.centerX < x + width && box.centerY > y && box.centerY < y + height
    })
    setBoxesSelector(newBoxes)
  }, [boxes_, selectorProps, setBoxesSelector])

  // 数量反馈父组件
  useEffect(() => {
    onBoxesLengthChange(boxesSelector.length)
  }, [boxesSelector, onBoxesLengthChange])

  // 接创建父组件boxes副本
  useEffect(() => {
    setBoxes_(boxes)
  }, [boxes, setBoxes_])

  // 平均半径
  const radius_ = useMemo(() => {
    if (boxes.length == 0) { return 0 }
    const res = boxes.reduce((accumulator, box) => accumulator + (box.width + box.height) / 5, 0) / boxes.length
    return parseInt(res) ;
  }, [boxes])

  useEffect(()=>{
    onRadiusChange(radius_)
  },[radius_,onRadiusChange])

  // 点击创建移除图元
  const onClick = (e) => {
    // console.log('e',e);
    const stage = e.target.getStage();
    const position = stage.getPointerPosition();
    const scaleX = stage.scaleX()
    const scaleY = stage.scaleY()
    const clickX = (position.x - stage.x()) / scaleX
    const clickY = (position.y - stage.y()) / scaleY

    let isNew = 1;
    const newBoxes = boxes_.filter((box) => {
      const [x, y, w, h] = box.bounding
      const isCliked = clickX > x && clickX < x + w && clickY > y && clickY < y + h
      if (isCliked) { isNew = 0 }
      return !(isCliked)
    })
    if (isNew) {
      const newRadius = optionRadius
      newBoxes.push({
        label: "pipe",
        probability: 1,
        bounding: [clickX - newRadius, clickY - newRadius, 2 * newRadius, 2 * newRadius], // upscale box
        centerX: clickX,
        centerY: clickY,
        width: 2 * newRadius,
        height: 2 * newRadius,
        isNew: true
      })
    }
    setBoxes_(newBoxes)
  }

  return <>
    <ZoomableStage
      stagePropes={stagePropes}
      setStagePropes={setStagePropes}
      onDraging={setIsDraging}
    >
      {
        image && <Layer>
          <Image image={image} />
          {
            boxesSelector.map((box) => {
              const { centerX, centerY, width, height, isNew } = box
              // const circleRadius = (radius |radius_ )|((width + height) / 5); // 圆的半径
              const circleRadius = optionRadius; // 圆的半径
              return <Group key={`${centerX}-${centerY}`}>
                <Circle x={centerX} y={centerY} radius={circleRadius} stroke={isNew ? "#e60052":"#5ecc02"} strokeWidth={5} fill={isNew ? "#f50057" : "#6ae603"} />
              </Group>
            })
          }
          <RectSelector
            onClick={(e)=>{ onClick(e) }}
            onTap={(e)=>{ !isDraging && onClick(e) }}
            shapeProps={selectorProps} isSelected={image} onChange={setSelectorProps} 
          />
        </Layer>
      }
    </ZoomableStage>
  </>
}

export default App;
